exports = module.exports = require("../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination__list .pagination__item a.pagination__link:hover {\n  color: red;\n}", ""]);

// exports
